import React, { useState } from 'react'
import { Button } from '../ui/button'
import Startup from '../../asset/Startup.png'
import Freelancers from '../../asset/Freelancers.png'
import Constrain from '../../asset/Constrain.png'
import Remote from '../../asset/Remote.png'
import '../../App.css'

export default function CollabrativeSpace() {
    const [hoveredCard, setHoveredCard] = useState(null)

    const scrollToBookATour = () => {
        const element = document.getElementById('book-a-tour');
        if (element) {
            const headerHeight = 105;
            const elementPosition = element.offsetTop - headerHeight;
            
            window.scrollTo({
                top: elementPosition,
                behavior: 'smooth'
            });
        }
    };

    const userTypes = [
        {
            id: 'startups',
            title: 'Startups',
            description: 'Small Growing Teams (2-10 People) Needing Collaboration',
            image: Startup,
            position: 'top',
        },
        {
            id: 'freelancers',
            title: 'Freelancers',
            description: 'Solo Operators who Need Structure and Focus',
            image: Freelancers,
            position: 'bottom',
        },
        {
            id: 'consultants',
            title: 'Consultants',
            description: 'Client-Facing Professionals who Value Location + Image',
            image: Constrain,
            position: 'top',
        },
        {
            id: 'remote',
            title: 'Remote Workers',
            description: 'Employees of Distributed Companies Seeking a Quiet Workspace',
            image: Remote,
            position: 'bottom',
        },
    ]

    const topRow = userTypes.slice(0, 2)
    const bottomRow = userTypes.slice(2)

    const renderCard = ({ id, title, description, image, position }) => (
        <div
            key={id}
            style={{ borderRadius: '20px' }}
            className={`flex flex-col cursor-pointer justify-center CollaborativeCatagory p-3 sm:p-4 items-center w-[200px] sm:w-[250px] h-[200px] sm:h-[250px] bg-[#FFF4F8] relative ${position === 'bottom' ? 'sm:bottom-[30px]' : ''}`}
            onMouseEnter={() => setHoveredCard(id)}
            onMouseLeave={() => setHoveredCard(null)}
        >
            <img className='w-[60px] sm:w-[80px] pb-3 sm:pb-4' src={image} alt={title} />
            <p className={`text-2xl sm:text-3xl font-regrade font-semibold text-center transition-all duration-300 ease-in-out ${hoveredCard === id ? 'text-[1.5rem] sm:text-[1.7rem]' : ''}`}>{title}</p>
            <p
                className={`text-center text-[#6D7E94] pt-2 text-sm transition-all duration-300 ease-in-out ${hoveredCard === id ? 'opacity-100 max-h-[100px]' : 'opacity-0 max-h-0 overflow-hidden'}`}
            >
                {description}
            </p>
        </div>

    )

    return (
        <div className='flex flex-col lg:flex-row items-center justify-around mt-16 max-w-[75rem] py-8 mx-auto px-4 sm:px-6 gap-8 lg:gap-0'>
            <div className="text-center lg:text-left">
                <h2 className="text-[#966376] font-sans mb-6 sm:mb-8 text-base sm:text-lg font-semibold uppercase">
                    Professional & Collaborative Spaces
                </h2>
                <h3 className="text-[#0B2549] font-regrade mb-6 sm:mb-8 text-2xl sm:text-3xl md:text-5xl font-bold leading-tight mt-3 max-w-4xl">
                    Work Smarter
                </h3>
                <h3 className="text-[#0B2549] font-regrade mb-6 sm:mb-8 text-2xl sm:text-3xl md:text-5xl font-bold leading-tight mt-3 max-w-4xl">
                    Create Better
                </h3>
                <h3 className="text-[#0B2549] font-regrade mb-6 sm:mb-8 text-2xl sm:text-3xl md:text-5xl font-bold leading-tight mt-3 max-w-4xl">
                    Grow Faster
                </h3>
                <Button onClick={scrollToBookATour}style={{borderRadius:'30px'}} className="text-[15px] text-white rounded-[30px] mr-0 sm:mr-8 px-5 hover:bg-[#7d5262] transition-colors w-full sm:w-auto">
                    Book A Tour
                </Button>
            </div>

            <div className="w-full lg:w-auto flex flex-col items-center">
                <div className='flex flex-col sm:flex-row gap-4 sm:gap-8 justify-center'>
                    {topRow.map(renderCard)}
                </div>
                <div className='flex flex-col sm:flex-row relative sm:left-[40px] pt-4 sm:pt-8 gap-4 sm:gap-8 justify-center'>
                    {bottomRow.map(renderCard)}
                </div>
            </div>
        </div>
    )
}
